import type { ClientBranding } from '~/services/branding/clientBranding';

import styles from './BrandCorner.module.css';

/**
 * Logo de l'établissement dans un coin de la TV pendant les jeux (formule Pro),
 * comme le logo d'une chaîne de télé. Posé par la console PAR-DESSUS l'iframe du
 * jeu : marche pour tous les jeux sans toucher à leur code. Le coin se choisit
 * dans Mon compte (un jeu peut avoir ses scores ou son QR dans un coin).
 * `pointer-events: none` : ne gêne jamais un clic sur la TV.
 */
export function BrandCorner({ branding }: { branding: ClientBranding | null }) {
    if (!branding?.logo) return null;
    return <img className={`${styles.corner} ${styles[branding.corner]}`} src={branding.logo} alt="" />;
}
